import filter from 'lodash/filter'
import sortBy from 'lodash/sortBy'
import moment from 'moment'

export function getQualifiedFlexDates(
  minRetailPrice,
  flexDates,
  startDate,
  returnDate,
  noOfFlexDatesToDisplay
) {
  let qualifiedFlexDates = []
  const cheapestAltDates = sortBy(flexDates, 'fare')
  const altDatesPriceThreshold = 20
  const searchFormatDepartDate = moment(startDate)
  const searchFormatReturnDate = moment(returnDate)
  const searchLengthOfStay = searchFormatReturnDate.diff(searchFormatDepartDate, 'days')

  qualifiedFlexDates = filter(cheapestAltDates, (itinerary) => {
    const cheaperFlexDateOption = Math.ceil(minRetailPrice - itinerary.fare) >= altDatesPriceThreshold
    let lengthOfStayInDays = 0
    if (itinerary.returnDate) {
      lengthOfStayInDays = moment(itinerary.returnDate).diff(moment(itinerary.departDate), 'days')
    }

    // correct length of stay is true if length of stay is +-1 from the search dates length of stay
    const isCorrectLengthOfStay =
      lengthOfStayInDays >= searchLengthOfStay - 1 && lengthOfStayInDays <= searchLengthOfStay + 1

    return cheaperFlexDateOption && isCorrectLengthOfStay
  })
  qualifiedFlexDates = qualifiedFlexDates.splice(0, noOfFlexDatesToDisplay)

  return qualifiedFlexDates
}

// Use origin and Destination from SearhcParams instead of the origin and destination from Flex Dates API
export function validateFlexDate(itinerary, minimumRetailPrice, searchOrigin, searchDestination) {
  let lengthOfStayText
  let lengthOfStayInDays = 0
  const formatDepartDate = moment(itinerary.departDate, 'YYYY-MM-DD').format('ddd, MMM D')
  const formatReturnDate = itinerary.returnDate
    ? moment(itinerary.returnDate, 'YYYY-MM-DD').format('ddd, MMM D')
    : ''
  const formatDepartDateUrl = itinerary.departDate.replace(new RegExp('-', 'g'), '')
  const formatReturnDateUrl = itinerary.returnDate
    ? itinerary.returnDate.replace(new RegExp('-', 'g'), '')
    : ''
  const retailAltPriceDiff = Math.ceil(minimumRetailPrice - itinerary.fare)
  if (itinerary.returnDate) {
    lengthOfStayInDays = moment(itinerary.returnDate).diff(moment(itinerary.departDate), 'days')
    lengthOfStayText = `${lengthOfStayInDays} ${Number(lengthOfStayInDays) > 1 ? 'nights' : 'night'}`
  }

  const sliceOneUrl = `${searchOrigin}-${searchDestination}-${formatDepartDateUrl}/`
  const sliceTwoUrl = itinerary.returnDate
    ? `${searchDestination}-${searchOrigin}-${formatReturnDateUrl}/`
    : ''
  const passengerUrl = `${itinerary.passengerUrl}`
  const newSearchUrl = `/m/fly/search/${sliceOneUrl + sliceTwoUrl}?cabin-class=${
    itinerary.cabinClass
  }&${passengerUrl}`
  return {
    retailAltPriceDiff,
    formatDepartDate,
    formatReturnDate,
    lengthOfStayText,
    flexDatePrice: Math.ceil(itinerary.fare),
    newSearchUrl,
  }
}

// SETI: AIR_FLEX_DATES_TILES_CONTAINER_RT, This method returns different date formats
// Use origin and Destination from SearhcParams instead of the origin and destination from Flex Dates API
export function validateFlexDateContainerRT(itinerary, minimumRetailPrice, searchOrigin, searchDestination) {
  let lengthOfStayText
  let lengthOfStayInDays = 0
  const formatDepartDay = moment(itinerary.departDate, 'YYYY-MM-DD').format('ddd')
  const formatDepartDate = moment(itinerary.departDate, 'YYYY-MM-DD').format('MM/DD')

  const formatReturnDate = itinerary.returnDate
    ? moment(itinerary.returnDate, 'YYYY-MM-DD').format('MM/DD')
    : ''
  const formatReturnDay = itinerary.returnDate ? moment(itinerary.returnDate, 'YYYY-MM-DD').format('ddd') : ''

  const formatDepartDateUrl = itinerary.departDate.replace(new RegExp('-', 'g'), '')
  const formatReturnDateUrl = itinerary.returnDate
    ? itinerary.returnDate.replace(new RegExp('-', 'g'), '')
    : ''
  const retailAltPriceDiff = Math.ceil(minimumRetailPrice - itinerary.fare)
  if (itinerary.returnDate) {
    lengthOfStayInDays = moment(itinerary.returnDate).diff(moment(itinerary.departDate), 'days')
    lengthOfStayText = `${lengthOfStayInDays} ${Number(lengthOfStayInDays) > 1 ? 'nights' : 'night'}`
  }

  const sliceOneUrl = `${searchOrigin}-${searchDestination}-${formatDepartDateUrl}/`
  const sliceTwoUrl = itinerary.returnDate
    ? `${searchDestination}-${searchOrigin}-${formatReturnDateUrl}/`
    : ''
  const passengerUrl = `${itinerary.passengerUrl}`
  const newSearchUrl = `/m/fly/search/${sliceOneUrl + sliceTwoUrl}?cabin-class=${
    itinerary.cabinClass
  }&${passengerUrl}`
  return {
    retailAltPriceDiff,
    formatDepartDate,
    formatReturnDate,
    lengthOfStayText,
    flexDatePrice: Math.ceil(itinerary.fare),
    newSearchUrl,
    formatReturnDay,
    formatDepartDay,
  }
}

export function maxSavingsText(qualifiedAltDates, minimumRetailPrice, seti) {
  let bestSaving = 0
  qualifiedAltDates.map((itinerary) => {
    const retailAltPriceDiff = Math.ceil(minimumRetailPrice - itinerary.fare)
    bestSaving = bestSaving < retailAltPriceDiff ? retailAltPriceDiff : bestSaving
    return itinerary
  })

  if (seti === 'VARIANT_ONE') {
    return `Flexible? Save up to $${bestSaving} when you fly another day!`
  } else if (seti === 'VARIANT_TWO') {
    return `Flexible? $${bestSaving} off when you fly another day!`
  }
  return 'Flexible? Fly another day to save!'
}

export function cheaperHeaderText(qualifiedAltDates) {
  let cheapestFlight
  qualifiedAltDates.map((itinerary) => {
    const flightPrice = Math.ceil(itinerary.fare)
    cheapestFlight = cheapestFlight < flightPrice ? cheapestFlight : flightPrice
    return itinerary
  })
  return cheapestFlight
}
